module.exports = __webpack_public_path__ + "img/个人简历图标-2.de215be8.png";